import { render, staticRenderFns } from "./ClassTickets.vue?vue&type=template&id=2c0aae36&"
import script from "./ClassTickets.vue?vue&type=script&lang=js&"
export * from "./ClassTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports